// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://jrxqksupabcvfnjxbeez.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpyeHFrc3VwYWJjdmZuanhiZWV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM4OTYwMTMsImV4cCI6MjA5OTQ3MjAxM30.1JefPMggnnWRDbVdJ3WT-vXHjdY2fwUW7gXxzemKIeE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // AuthPage parses invite/recovery links manually. Leaving this on causes a
    // race where the client consumes (and invalidates) the hash tokens before
    // AuthPage can call setSession, producing "Auth session missing!" at the
    // set-password step. Manual handling is the single source of truth.
    detectSessionInUrl: false,
    flowType: 'implicit',
  }
});

// Mark sign-outs that originate from THIS tab so ProtectedRoute can
// distinguish them from cross-tab SIGNED_OUT broadcasts (which otherwise
// force-log-out every open tab in the browser).
//
// Also force `scope: 'local'`. Supabase's default is GLOBAL sign-out, which
// revokes every server-side session for that user on every device. Staff who
// switch between multiple accounts were therefore killing their own sessions
// on other devices/kiosk tabs: the cached JWT stayed signature-valid (so RLS
// kept working) but Edge Functions' `auth.getUser()` returned
// "Session not found" → Unauthorized. Local sign-out only clears this browser.
const _originalSignOut = supabase.auth.signOut.bind(supabase.auth);
supabase.auth.signOut = (async (options?: { scope?: 'global' | 'local' | 'others' }) => {
  (window as unknown as { __lovableLocalSignOut?: boolean }).__lovableLocalSignOut = true;
  try {
    return await _originalSignOut({ scope: 'local', ...(options ?? {}) });
  } finally {
    setTimeout(() => {
      (window as unknown as { __lovableLocalSignOut?: boolean }).__lovableLocalSignOut = false;
    }, 1000);
  }
}) as typeof supabase.auth.signOut;
